import {defaultIO} from "../DefaultIO";
import {ShoppingFunnelValueObject} from "../../model/vo/content/ShoppingFunnelValueObject";
import {ShoppingTotalMetricsValueObject} from "../../model/vo/content/ShoppingTotalMetricsValueObject";
import {httpClient} from "../HttpClient";

export const ShoppingFunnelIO = {
        ...defaultIO(
        '/api/v3/contents/shoppings/funnel',
        ShoppingFunnelValueObject.construct
    ),
    getShoppingTotalMetrics(exposedAt: string): Promise<ShoppingTotalMetricsValueObject> {
            return httpClient.get(
                `/api/v3/contents/shoppings/funnels/metrics?exposedAtEqual=${exposedAt}&deletedAtIsNull`
                ,ShoppingTotalMetricsValueObject.construct)
    }
}